
import React from 'react';
import { useAppState } from '../../context/AppStateContext';
import HomePage from '../../features/home/HomePage';
import BusinessPage from '../../features/business/BusinessPage';
import StudioPage from '../../features/studio/StudioPage';
import OpsPage from '../../features/ops/OpsPage';

export default function PageRenderer() {
  const { appState } = useAppState();

  switch (appState.currentPage) {
    case 'home': return <HomePage />;
    case 'business': return <BusinessPage />;
    case 'studio': return <StudioPage />;
    case 'ops': return <OpsPage />;
    default: return <HomePage />;
  }
}
